import { put, takeLatest, call } from 'redux-saga/effects';
import { SIGN_IN_REQUEST, LOAD_REGISTERED_USER } from '../actions/sigin';
import { setTokens } from '../actions/token';
import { signInService } from '../services/signIn';
import { setUserLogin } from '../../home/actions/loggedUser';
import { getUsers } from '../../users/services/users';
import { cdnLogin } from '../../app/conf';
import { getAuthProfile, getViewerProfile } from '../../app/helpers/conf';

const signInWorker = function* (action) {
    try {
        const { username, password, history } = action.payload;

        const {
            data: { access_token: accessToken, refresh_token: refreshToken, user }
        } = yield call(signInService, username, password);

        const {
            data: { users }
        } = yield call(getUsers, { identifier: user._id, full_company: 1, full_profile: 1 }, accessToken);

        yield put(setUserLogin({ user: users[0] || user }));

        yield put(setTokens(accessToken, refreshToken));

        history.push('/');
    } catch (err) {
        window.location.href = cdnLogin;
    }
};

const loadRegisteredUserWorker = function* ({ payload: { user_id, access_token, refresh_token, history } }) {
    try {
        const {
            data: { users }
        } = yield call(getUsers, { identifier: user_id, full_company: 1, full_profile: 1 }, access_token);

        yield put(setTokens(access_token, refresh_token));

        const accessLevel = users[0] && users[0].profile[0] ? users[0].profile[0].accessLevel : "";
        const isViewer = users[0]?.profile[0]?.code === 'viewer';

        const { authRole, authEntities, defaultInitialRoute } = isViewer
            ? getViewerProfile()
            : getAuthProfile(accessLevel);

        yield put(setUserLogin({
            user: users[0],
            permisionEntities: authEntities,
            permission: authRole
        }));

        history.push(defaultInitialRoute);
    } catch (err) {
        console.log(err);
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = cdnLogin;
    }
};

export default [takeLatest(SIGN_IN_REQUEST, signInWorker), takeLatest(LOAD_REGISTERED_USER, loadRegisteredUserWorker)];
